import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { AddPrescriptionVisitModal } from './AddPrescriptionVisitModal';

type AddPrescriptionVisitModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type AddPrescriptionVisitModalOpenerProps = {
   readonly children: (renderProps: AddPrescriptionVisitModalOpenerRenderProps) => ReactElement;
};

export const AddPrescriptionVisitModalOpener = (props: AddPrescriptionVisitModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <AddPrescriptionVisitModal onClose={closeModal} /> : null}
      </>
   );
};
